import { FC } from "react";
import {
  CARD_TAGS_DEFAULTS,
  CARD_TAG_CLASS_MAP,
  TCardTagsProps,
} from "./Card.config";
import { Badge, Pill } from "../../primitives";
import { cn } from "@/ui/lib";

export const CardTags: FC<TCardTagsProps> = ({
  tags,
  variant = CARD_TAGS_DEFAULTS.variant,
}) => (
  <>
    { tags?.topLeft ? (
      <Pill {...tags.topLeft} className={cn("absolute top-2", CARD_TAG_CLASS_MAP[variant].topLeft)} />
    ) : null }
    { tags?.bottomLeft ? (
      <Badge {...tags.bottomLeft} className={cn("absolute bottom-0 translate-y-1/2", CARD_TAG_CLASS_MAP[variant].bottomLeft)} />
    ) : null }
    { tags?.bottomRight ? (
      <Pill {...tags.bottomRight} className={cn("absolute bottom-0 translate-y-1/2", CARD_TAG_CLASS_MAP[variant].bottomRight)} />
    ) : null }
  </>
);
